import { h } from "vue";

import GenericCard from "@/components/EntityInfo/GenericCard.vue";
import { type DomainTerm } from "@/stores/domain-terms-store";
import { EntityType } from "@/stores/entity-store";
import { vnodeToHtml } from "@/utils";

import {
    LinkedEntity,
    createEntityExtension,
} from "../mystekz-linked-entities";
import { DomainTermsManager } from "./manager";

export type DomainTermEntity = LinkedEntity<"domain_term", DomainTerm>;

let domainTermsManager: DomainTermsManager;
/**
 * Get the domain term manager for a given domain.
 */
export const getDomainTermsManager = (baseUrl: string) => {
    if (!domainTermsManager) {
        domainTermsManager = new DomainTermsManager(baseUrl);
    }
    return domainTermsManager;
};

export const DomainTermsExtension = createEntityExtension(
    "domain_term",
    import.meta.env.VITE_BASE_URL,
    true,
    {
        popup: {
            key: "domainTermDetails",
            hover: true,
            create: (_: Promise<DomainTermEntity | void>, entityId: string) => {
                return () => {
                    return vnodeToHtml(
                        h(GenericCard, {
                            entityId,
                            entityType: EntityType.DOMAIN_TERM,
                        })
                    );
                };
            },
        },
        prefix: "",
    },
    {
        popup: {
            key: "domainTermInsert",
        },
    },
    getDomainTermsManager,
    {
        label: "Terminoloy",
        showInInlineMenu: true,
        caret: true,
        icon: {
            name: "pi-book",
            library: "primeicons",
        },
        group: "Linked Domain Objects",
    }
);
